import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getToastProps } from '../../store/selectors';

import { toastActions } from '../../store';
import { GeneralToast } from 'Containers/Scheduler/containers/Toast/general';
import { toast } from 'react-toastify';

const getToastConfig = (toastProps = {}) => {
  const { warning, variant } = toastProps;
  let className = 'toast-info';
  let progressClassName = 'toast-info_progress';

  if (warning) {
    className = 'toast-warning';
    progressClassName = 'toast-warning_progress';
  } else if (variant === 'movedHidden') {
    className = 'toast-moved-hidden';
    progressClassName = 'toast-moved-hidden_progress';
  } else if (variant === 'movedActive') {
    className = 'toast-success';
    progressClassName = 'toast-success_progress';
  }

  return {
    autoClose: 4000,
    className,
    hideProgressBar: false,
    progressClassName,
    closeOnClick: true,
    theme: 'light',
    icon: false,
  };
};

export default () => {
  const dispatch = useDispatch();
  const { type, props } = useSelector(getToastProps());
  const closeAllToasts = () => {
    dispatch(toastActions.CLOSE_TOAST.SUCCESS());
  };

  const setToast = (toastType) => {
    toast(
      <GeneralToast booking={props} type={toastType} />,
      getToastConfig(props),
    );
    closeAllToasts();
  };

  useEffect(() => {
    if (type) setToast(type);
  }, [type]);

  return null;
};
